var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6946 24.6579L17.9509 1.11404C17.5437 0.41645 16.8144 0 16 0C15.1856 0 14.4563 0.41645 14.0491 1.11404L0.305438 24.6579C-0.101812 25.3555 -0.101812 26.1884 0.305438 26.886C0.712625 27.5836 1.44194 28 2.25638 28H29.7436C30.5581 28 31.2874 27.5836 31.6946 26.886C32.1018 26.1884 32.1018 25.3555 31.6946 24.6579ZM30.0688 25.9576C30.0284 26.027 29.9322 26.1433 29.7437 26.1433H2.25638C2.06775 26.1433 1.97162 26.027 1.93125 25.9576C1.89081 25.8883 1.83694 25.7478 1.93125 25.5863L15.6748 2.04238C15.7691 1.88086 15.919 1.85669 15.9999 1.85669C16.0809 1.85669 16.2308 1.88079 16.3251 2.04238L30.0688 25.5863C30.1631 25.7478 30.1093 25.8883 30.0688 25.9576Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.939 8.44249H15.0617V18.3451H16.939V8.44249Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 22.6776C16.6915 22.6776 17.2519 22.1234 17.2519 21.4397C17.2519 20.7561 16.6915 20.2019 16.0003 20.2019C15.3091 20.2019 14.7487 20.7561 14.7487 21.4397C14.7487 22.1234 15.3091 22.6776 16.0003 22.6776Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWhite);
export default __webpack_public_path__ + "static/media/warning_white.8d93008cd6e2925269a02149c8910a11.svg";
export { ForwardRef as ReactComponent };